import React from 'react';
import 'partial/OfferManager/modules/CreditLimit/CreditLimitView.scss';
import SectionContainer from 'components/Containers/SectionContainer';
import { PageContainer } from 'components/Containers/PageContainer/PageContainer';
import TextFromConfig from 'components/TextFromConfig';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import UnifiedCCOffersContainer from 'partial/OfferManager/UnifiedCCOffersContainer';
import { Row } from 'components/Containers/Row/Row';
import { TitleContainer } from 'components/Containers/TitleContainer/TitleContainer';
import { SeeAllCards } from 'components/Offers/SeeAllCards/SeeAllCards';
import Label from 'components/form/Label/Label';
import { CREDIT_LIMIT_ACTION } from 'types/morph.pagePosition.constants';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';

const CreditLimitView = props => {
  const defaultTestId = 'CreditLimitView';
  return (
    <PageContainer className="CreditLimitView">
      {props.seenPixel}
      <Disclaimer
        showPartnerText
        datatestid="CreditLimitView"
        className={'margb8 m-padlr8'}
      />
      <SectionContainer>
        <Row type="action" className="cr-headerSimulationSection">
          <div className="cr-header-container">
            <TitleContainer className="creditRepairTitle">
              <Label
                type="H3"
                typeHeader={'h1'}
                datatestid={`${defaultTestId}-title`}
              >
                <TextFromConfig
                  path={TextFromConfig.paths.CREDIT_LIMIT_HEADER}
                />
              </Label>
            </TitleContainer>
            <Label
              type="Body-1 m-text-14"
              datatestid={`${defaultTestId}-subHeader`}
            >
              <TextFromConfig
                path={TextFromConfig.paths.CREDIT_LIMIT_PARAGRAPH}
              />
            </Label>
          </div>
        </Row>
        <FlexContainer className={'flex-column'}>
          <UnifiedCCOffersContainer
            {...props}
            containerType="CREDIT_LIMIT"
            datatestid={defaultTestId}
            pagePosition={CREDIT_LIMIT_ACTION}
            showSeeMoreCardsLink={false}
            seeAllCards={
              <SeeAllCards
                link="/offers/creditcard"
                description="See More Credit Cards"
                sizeClass="small"
                onLinkClickCallback={props.onLinkClickCallback}
                key="see-all"
              />
            }
          />
        </FlexContainer>
      </SectionContainer>
    </PageContainer>
  );
};

export default CreditLimitView;
